import { Business } from "../../shared/models";

export interface BusinessQueueTasks{
    accept_incoming:boolean;
    business: Business;
    cron_string: string;
    data_info:string;
    html_template:string;
    id: number;
    mail_bcc_recipient_list:string;
    mail_cc_recipient_list:string;
    mail_recipient_list:string;
    name:string;
    queue: string;
    should_proccess:boolean;
    service_provider:string;
};


export const BusinessQueueTypes =[
    {   
        id: 1,
        type:'korona_db_sync',
        value:'Korona DB Sync'
    },
    {
        id: 2,
        type:'korona_load_older_receipts',
        value:'Korona Load Older Receipts'
    },
    {
        id: 3,
        type:'custom_reports',
        value:'Custom Reports'
    },
    {
        id: 4,
        type:'receipt_index_catch_up',
        value:'Receipt Index Catch Up'
    },
    {
        id: 5,
        type:'es_sync_sales_report',
        value:'ES Sales Data Summary'
    },
    {
        id: 6,
        type:'homesome_sales_report',
        value:'Homesome Sales Report'
    },
    {
        id: 7,
        type:'korona_receipts_only_sync',
        value:'Korona Receipts Only Sync'
    },
    {
        id: 8,
        type:'stock_order_customer_order',
        value:'Stock Order Customer Order'
    },
    {
        id: 9,

        type:'customer_order_stock_receipt',
        value:'Customer Order Stock Receipt'
    },
    {
        id: 10,
        type:'notification_events',
        value:'Notification Events'
    },
]

export interface ConversionJob {
    id: number;
    business: number;
    business_name: string;
    job_type: string;
    stock_order: number | null;
    customer_order: number | null;
    stock_order_number?: string | null;
    stock_order_uuid?: string | null;
    customer_order_number?: string | null;
    customer_order_uuid?: string | null;
    status: string;
    attempts: number;
    last_error: string | null;
    dedupe_key: string;
    locked_at: string | null;
    created_at: string;
    updated_at: string;
}

export const ConversionJobTypes = [
    { id: 1, type: 'stock_order_to_customer_order', value: 'Stock Order -> Customer Order' },
    { id: 2, type: 'customer_order_to_stock_receipt', value: 'Customer Order -> Stock Receipt' },
];

export const ConversionJobStatuses = [
    { id: 1, type: 'pending', value: 'Pending' },
    { id: 2, type: 'processing', value: 'Processing' },
    { id: 3, type: 'succeeded', value: 'Succeeded' },
    { id: 4, type: 'failed', value: 'Failed' },
    { id: 5, type: 'dead', value: 'Dead' },
    { id: 6, type: 'mapping_error', value: 'Mapping Error' },
];